import SocialVisual1 from "../../img/screenshots/profile/profile-01.png";
import SocialVisual2 from "../../img/screenshots/profile/profile-02.png";
import SocialVisual3 from "../../img/screenshots/profile/profile-03.png";
import SocialVisual4 from "../../img/screenshots/profile/profile-04.png";

export const SocialFeaturesContent = [
  {
    title: "Create your own travel community",
    subtitle: "Follow friends & other travelers",
    text: "Build your own squad of adventurers!  Add friends, fellow travelers, and like-minded explorers to follow their journeys. See/use their itineraries and swap tips to make every trip unforgettable. Because traveling is better when shared!",
    image: SocialVisual1,
  },
  {
    title: "Save the places you want to go in your next travels",
    subtitle: "Add places to wishlist",
    text: "Keep track of all those “must-visit” spots for your next trip! Whether it's that dreamy café or a hidden waterfall, save your favourite places, restaurants, and experiences in one handy list. When it’s time to plan, your next itinerary is already halfway done.",
    image: SocialVisual2,
  },
  {
    title: "Let your friends & family know about the best spots",
    subtitle: "Recommend the places you loved",
    text: "Why keep those insider tips to yourself? Share your top picks, and help other travelers discover the best spots. From epic restaurants to can't-miss landmarks, your reviews guide the way for others.",
    image: SocialVisual3,
  },
  {
    title: "Show your friends & family some love",
    subtitle: "Interact with your followers",
    text: "Like and comment on your friends' travel journals and be part of their adventure. Give them some travel tips while they're on the move, they'll thank you later.",
    image: SocialVisual4,
  },
];
